import {
    AllocationElementDiagramAnchor,
    AllocationElementDiagramVersion,
} from 'src/models/anchor-and-version/allocation-element-diagram.model';
import { createBaseAnchor, createBaseVersion } from './base.factory';

export function createAllocationElementDiagramAnchor(
    aParams: {
        // Base
        logText: string;
        // Specific
        userFunctionAnchorKey: number;
    },
    vParams: {
        // Base
        comment: string;
        logText: string;
        name: string;
    }
): AllocationElementDiagramAnchor {
    const version = createAllocationElementDiagramVersion({
        ...vParams,
        anchorKey: 0,
        changeRequestKey: 1,
    });
    const anchor: AllocationElementDiagramAnchor = {
        ...createBaseAnchor(aParams),
        userFunctionAnchorKey: aParams.userFunctionAnchorKey,
        aeBoxAnchors: null,
        noteBoxAnchors: null,
        displayName: null,
        allVersions: [version],
        validVersion: version,
    };

    return anchor;
}

export function createAllocationElementDiagramVersion(params: {
    // Base
    anchorKey: number;
    changeRequestKey: number;
    comment: string;
    logText: string;
    name: string;
}): AllocationElementDiagramVersion {
    const baseVersion = createBaseVersion(params);
    const version: AllocationElementDiagramVersion = {
        ...baseVersion,
    };

    return version;
}
